import React, { memo } from 'react';
import { Container, Grid, Theme, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import PromoProgramsDescription from './PromoProgramsDescription';
import PromoProgramsPicture from './PromoProgramsPicture';

interface IProps {
  forChannel?: boolean;
  mainTitleKey?: string;
  mainTitleStyle?: any;
  titleKey: string;
  titleStyle?: any;
  src: string;
  market: string;
  marketTextKey?: string;
  backgroundPosition?: string;
  supportByImageScr?: string;
  imageMarginBottom?: number;
  imageMaxWidth?: number;
}

interface StyleProps {
  imageMarginBottom?: number;
}

// TODO jss-to-tss-react codemod: '@global' is not supported by tss-react.
// See https://mui.com/material-ui/customization/how-to-customize/#4-global-css-override for alternatives.
const useStyles = makeStyles<StyleProps>()((theme, params) => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.custom.white,
    },
  },
  wrapper: {
    position: 'relative',
    marginBottom: theme.spacing(9),
    [theme.breakpoints.up('xs')]: {
      marginBottom: '82px',
    },
  },
  root: {
    backgroundColor: theme.palette.background.default,
    borderBottomLeftRadius: 220,
    // width: '93.472%',
    width: '96%',
    right: 0,
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      borderBottomLeftRadius: 110,
    },
    position: 'absolute',
    top: 0,
    bottom: 0,
  },
  mainContainer: {
    padding: '0px 24px',
  },
  image: {
    transform: 'translateY(78px)',
    ...(params?.imageMarginBottom && { marginBottom: params?.imageMarginBottom }),
  },
}));

const PromoPrograms: React.FC<React.PropsWithChildren<IProps>> = (props) => {
  const {
    forChannel,
    mainTitleKey,
    mainTitleStyle,
    titleKey,
    titleStyle,
    src,
    backgroundPosition,
    imageMarginBottom,
    imageMaxWidth,
    ...rest
  } = props;
  const { classes } = useStyles({ imageMarginBottom });
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('md'));

  return (
    <div className={classes.wrapper}>
      <div className={classes.root} />
      <Container className={classes.mainContainer} maxWidth="lg">
        <Grid container justifyContent={isMobile ? 'center' : 'space-between'} wrap="nowrap" alignItems="center">
          <Grid item>
            <PromoProgramsDescription
              mainTitleKey={mainTitleKey}
              mainTitleStyle={mainTitleStyle}
              titleKey={titleKey}
              titleStyle={titleStyle}
              backgroundPosition={backgroundPosition}
              {...rest}
            />
          </Grid>
          {!isMobile &&
            (forChannel ? (
              <Grid item>
                <PromoProgramsPicture src={src} backgroundPosition={backgroundPosition} imageMaxWidth={imageMaxWidth} />
              </Grid>
            ) : (
              <Grid item className={classes.image}>
                <PromoProgramsPicture src={src} backgroundPosition={backgroundPosition} imageMaxWidth={imageMaxWidth} />
              </Grid>
            ))}
        </Grid>
      </Container>
    </div>
  );
};

export default memo(PromoPrograms);
